module.exports = __webpack_public_path__ + "static/img/capital_meter.5166a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/capital_meter.png
// module id = Q/BT
// module chunks = 4